import { InfiniteTable } from '@/components/_common';
import ActionIcon from '@/components/_common/ActionIcon';
import {
  useWorkOrderMigrationConsultBindComplement,
  useWorkOrders,
} from '@/core/domain/workorder/WorkOrders/WorkOrders.hooks';
import { ListWorkOrdersResult } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';
import { useDisclosure } from '@/hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Button, Modal, Popover } from 'antd';
import { Check, Link } from 'react-feather';
import useWorkOrdersColumns from '../../List/useWorkOrdersColumns';
import { useCallback } from 'react';

interface Props {
  migrationId: number;
}

export default function MigrationBindComplements(props: Props) {
  const [opened, action] = useDisclosure();

  const workOrderList = useWorkOrders({}, opened);
  const migrationBindComplement = useWorkOrderMigrationConsultBindComplement();

  const isLoading = migrationBindComplement.isLoading;

  const workOrders = flatInfiniteData(workOrderList.data);

  const { columns } = useWorkOrdersColumns({ withAction: false });

  const handleSubmit = async (workOrder: ListWorkOrdersResult) => {
    try {
      await migrationBindComplement.mutateAsync({
        migratedComplementId: props.migrationId,
        complementId: workOrder.complementId,
        workOrderId: workOrder.workOrderId,
      });
      action.close();
    } catch {}
  };

  const handleClose = useCallback(() => {
    if (isLoading) return;
    action.close();
  }, [isLoading]);

  return (
    <>
      <Popover content="Vincular">
        <ActionIcon onClick={action.open}>
          <Link size={18} />
        </ActionIcon>
      </Popover>

      <Modal
        open={opened}
        onCancel={handleClose}
        title="Vincular orçamentos cadastrados"
        width="100%"
        footer={false}
        closable={!isLoading}
        maskClosable={!isLoading}
      >
        <p>Selecione um complemento para vincular a consulta de migração.</p>

        <InfiniteTable
          dataSource={workOrders}
          columns={[
            ...columns,
            {
              title: 'Selecionar',
              fixed: 'right',
              align: 'right',
              width: 80,
              render: (_, item) => (
                <Button
                  icon={<Check />}
                  shape="circle"
                  loading={
                    migrationBindComplement.isLoading &&
                    migrationBindComplement.variables?.complementId ===
                      item.complementId
                  }
                  onClick={() => handleSubmit(item)}
                />
              ),
            },
          ]}
          fetchNextPage={workOrderList.fetchNextPage}
          hasNextPage={workOrderList.hasNextPage}
          isFetching={workOrderList.isFetching}
          loading={workOrderList.isLoading}
          rowKey={(item) => item.complementId}
          scroll={{ x: true }}
        />
      </Modal>
    </>
  );
}
